import { cva } from "class-variance-authority";

export const promoCarouselArrowVariants = cva(
  [
    "absolute top-[calc(50%+4px)] z-10 -mt-3 rounded-full border-solid",
    "dark:border-border dark:bg-background dark:hover:bg-muted",
    "pointer-events-none opacity-0 transition-opacity",
    "group-hover/promo-carousel:pointer-events-auto! group-hover/promo-carousel:opacity-100!",
    "focus-visible:pointer-events-auto! focus-visible:opacity-100!",
    "@max-[600px]:hidden!",
  ],
  {
    variants: {
      direction: {
        previous: "start-0 -ms-3",
        next: "end-0 -me-3",
      },
    },
  },
);
